module.exports = __webpack_public_path__ + "img/slider.a003fb8f.png";